export function TCell(props) {
  return (
    <th {...props}>
      {props.children}
    </th>
  )
}

export function Caption(props) {
  return (
    <caption {...props}>
      {props.children}
    </caption>
  )
}

export function Cell(props) {
  return (
    <td {...props}>
      {props.children}
    </td>
  )
}

export function Row(props) {
  return (
    <tr {...props}>
      {props.children}
    </tr>
  )
}

export function Body(props) {
  return (
    <tbody {...props}>
      {props.children}
    </tbody>
  )
}

export function Head(props) {
  return (
    <thead {...props}>
      {props.children}
    </thead>
  )
}

export function Foot(props) {
  return (
    <tfoot {...props}>
      {props.children}
    </tfoot>
  )
}


export default function Tabla(props) {
  return (
    <table {...props}>
      {props.children}
    </table>
  )
}
